<template>
  <Row>
    <i-col span="15">
      <i-select
        :value="currentID"
        @on-change="value => updateValue({ id: value })"
        filterable
        style="padding-right:6px;"
        not-found-text="Master facts require matching fields 'Country', 'Displacement type', 'Fact type' and 'Year' to be provided"
      >
        <i-option
          v-for="option in options"
          :value="option.id"
          :label="option.name"
          :key="option.id"
        >
          <div>
            <strong>{{ option.name }}</strong>
          </div>
          <div>
            <small>
              {{ option.id }} - {{ option.serial_no }} -
              {{ option.displacement_type }} - {{ option.type }} -
              {{ option.country }} - {{ option | getFigureDate }}
            </small>
          </div>
        </i-option>
      </i-select>
    </i-col>
    <i-col span="6">
      <i-select
        :value="currentRole"
        @on-change="value => updateValue({ role: value })"
        clearable
        style="padding-right:6px;"
      >
        <i-option value="Recommended figure">Recommended figure</i-option>
        <i-option value="Partial figure (Added)">Partial figure (Added)</i-option>
        <i-option value="Partial figure (Subtracted)">Partial figure (Subtracted)</i-option>
        <i-option value="Triangulation">Triangulation</i-option>
      </i-select>
    </i-col>
    <i-col span="3">
      <i-button
        icon="alert-circled"
        @click="value => updateValue({ id:null, role: null })"
        :disabled="currentID === null"
        style="width:100%;"
      >Clear</i-button>
    </i-col>
  </Row>
</template>

<script>
import _ from "lodash";
import axios from "axios";

export default {
  Name: "MasterFactAssociation",
  props: ["id", "role", "conditions"],
  data() {
    return {
      options: [],
      currentConditions: null,
      currentID: this.id,
      currentRole: this.role || "",
    };
  },
  watch: {
    id(newValue) {
      this.currentID = newValue;
    },
    role(newValue) {
      this.currentRole = newValue;
    },
    conditions: {
      immediate: true,
      handler() {
          this.loadOptions();
      },
    },
  },
  filters: {
    getFigureDate(entity) {
      let date = null;
      if (_.includes(entity.type, "Stock")) {
        date = entity.stock_date;
      } else {
        date = entity.start_date;
      }
      return date !== null ? date : "";
    },
  },
  methods: {
    async loadOptions() {
      const { iso3, displacement_type, type, year } = this.conditions;

      // Trying to skip same request to the server.
      const keySort = Object.keys(this.conditions).sort()
      if (JSON.stringify(this.conditions, keySort) === JSON.stringify(this.currentConditions, keySort)) {
          console.warn('::skipping');
          return;
      }
      this.currentConditions = {iso3, displacement_type, type, year};

      try {
        let response = await axios.get(`/psql/facts_view`, {
          params: {
            class: "eq.Master",
            iso3: `eq.${iso3}`,
            displacement_type: `eq.${displacement_type}`,
            type: `eq.${type}`,
            year: `gte.${year - 1}`,
            order: "created_at.desc",
          },
        });
        this.options = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    updateValue(value) {
      let payload = { id: this.id, role: this.role, ...value };
      // Manage role
      if (!payload.id) {
        payload.id = null;
        payload.role = null;
      } else if (!payload.role || payload.role === "") {
        payload.role = "Partial figure (Added)";
      }
      this.$emit("change", payload);
    },
  },
};
</script>

<style lang="css"></style>
